import axios from '@/jslib/axios'

export const getSpecialTeamList = data => {
  return axios({
    method: 'post',
    url: '/admin/special/team/list',
    data
  })
}
export const createSpecialTeam = data => {
  return axios({
    method: 'post',
    url: '/admin/special/team/create',
    data
  })
}
export const getSpecialTeamDetailList = data => {
  return axios({
    method: 'post',
    url: '/admin/special/team/detail',
    data
  })
}
export const getSpecialTeamSummary = params => {
  return axios({
    method: 'get',
    url: '/admin/special/team/summary',
    params
  })
}
export const changeSpecialTeam = data => {
  return axios({
    method: 'post',
    url: '/admin/special/team/change',
    data
  })
}
export const joinSpecialTeam = data => {
  return axios({
    method: 'post',
    url: '/admin/special/team/join',
    data
  })
}
export const getQuarterMonthList= params => {
  return axios({
    method: 'get',
    url: '/admin/account/team/quarter',
    params
  })
}